/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const refresh_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M1.374 8.295a.75.75 0 1 0 1.417.494l-1.417-.494Zm20.543.247-.708.247.072.207.173.136.463-.59Zm.708 7.163a.75.75 0 1 0-1.416-.494l1.416.494Zm-20.542-.247.708-.247-.072-.207-.173-.136-.463.59ZM22.5 9v.75a.75.75 0 0 0 .75-.75h-.75Zm.75-6.5a.75.75 0 0 0-1.5 0h1.5ZM16 8.25a.75.75 0 0 0 0 1.5v-1.5Zm-8 7.5a.75.75 0 0 0 0-1.5v1.5ZM1.5 15v-.75a.75.75 0 0 0-.75.75h.75Zm-.75 6.5a.75.75 0 0 0 1.5 0H.75ZM2.79 8.789A9.754 9.754 0 0 1 12 2.25V.75C7.084.75 2.906 3.903 1.374 8.295l1.417.494ZM12 2.25a9.754 9.754 0 0 1 9.209 6.539l1.416-.494C21.095 3.903 16.916.75 12 .75v1.5Zm9.209 12.961A9.754 9.754 0 0 1 12 21.75v1.5c4.916 0 9.094-3.153 10.625-7.545l-1.416-.494ZM12 21.75a9.754 9.754 0 0 1-9.21-6.539l-1.416.494C2.906 20.097 7.084 23.25 12 23.25v-1.5ZM23.25 9V2.5h-1.5V9h1.5Zm-.75-.75H16v1.5h6.5v-1.5Zm-14.5 6H1.5v1.5H8v-1.5ZM.75 15v6.5h1.5V15H.75Zm20.704-5.868.583.458.926-1.18-.582-.458-.927 1.18ZM2.546 14.868l-.583-.458-.926 1.18.582.458.927-1.18Z"
    />
  </svg>
)
export default refresh_medium
